import SystemBrand from "@/components/graphics/SystemBrand";
import ASLogo from "@/components/graphics/ASLogo";
import AppSwitcher from "@/components/layouts/AppSwitcher";
import AppNavItems from "@/components/layouts/AppNavItems";
import NavbarUserMenu from "@/components/layouts/NavbarUserMenu";
import { useNavbarUserMenu } from "@/hooks/useNavbarUserMenu";

const AppNavbar = () => {
  const { userInfo } = useNavbarUserMenu();

  return (
    <header className="navbar app-navbar px-4 py-2 bg-white sticky-top position-sticky flex-nowrap navbar--shadow">
      <div className="d-flex align-items-center gap-3 flex-shrink-0 app-navbar__brand">
        <a
          className="text-logo d-flex align-items-center"
          target="_blank"
          rel="noreferrer"
          href="https://www.advokatsamfundet.dk/"
          aria-label="Advokatsamfundet"
        >
          <ASLogo height={42} />
        </a>
        <span className="app-navbar__divider" />
        {userInfo?.role === "TokenUser" ? <SystemBrand /> : <AppSwitcher />}
      </div>

      <div className="flex-grow-1 d-flex justify-content-center px-3 app-navbar__nav">
        <AppNavItems />
      </div>

      <div className="d-flex align-items-center gap-2 ms-auto flex-shrink-0 app-navbar__actions">
        <NavbarUserMenu />
      </div>
    </header>
  );
};

export default AppNavbar;
